import React, { useEffect } from 'react'
import { Select } from '@retailer-platform/shared-components/src/common/select/Select'
import {
  type SelectProps,
  type SimpleOption,
} from '@retailer-platform/shared-components/src/common/select/utils/select.types'
import { useAccountManagementRetailers } from 'domains/account-management/components/retailer-select/utils/AccountManagementRetailerSelect.hooks'
import { useDomainMessages } from 'domains/account-management/utils/domain/intl'
import { idsSelectStyles } from 'domains/account-management/styles/accountManagement.styles'

interface Props {
  partnerIds: string[]
  isUpdate: boolean
  isDisabled?: boolean
}

interface OptionType {
  label: string
  value: string
}

export const AccountManagementRetailerSelect = ({
  value,
  onChange,
  partnerIds,
  isDisabled,
  isUpdate,
  ...props
}: Props & Omit<SelectProps<SimpleOption<OptionType>>, 'options' | 'isMulti'>) => {
  const { options, loading, error } = useAccountManagementRetailers(partnerIds)

  const i18n = useDomainMessages({
    placeholderMessage: 'accountManagementDomain.internalTerms.retailers.placeholder',
    loadingMessage: 'accountManagementDomain.internalTerms.retailers.loading',
  })

  // on create if there is only one option to select, select it
  useEffect(() => {
    if (
      !isUpdate &&
      !loading &&
      !isDisabled &&
      options.length === 1 &&
      options[0].options.length === 1
    ) {
      onChange(options[0].options)
    }
  }, [isDisabled, isUpdate, loading, onChange, options])

  return (
    <Select
      loading={loading}
      placeholder={i18n.placeholderMessage}
      loadingMessage={i18n.loadingMessage}
      options={options}
      error={error}
      isDisabled={isDisabled}
      {...props}
      value={value}
      onChange={onChange}
      isMulti={true}
      emptyValue={undefined}
      styles={{
        control: idsSelectStyles.control,
      }}
    />
  )
}
